import globalEventBus from 'toxilibs/event_bus_queued.js'
import KeyBinder from 'toxilibs/key_binder.js'

let eventBus = globalEventBus('user controls')


let directions = ['left', 'right', 'up', 'down']


for (let i = 0; i < directions.length; i++) {
    addEventForDirection(directions[i])
}


let api

eventBus.on('world api loaded', function (_api) {
    api = _api
})

eventBus.on('world unloaded', function () {
    api = null
})


function addEventForDirection (direction) {
    KeyBinder.onPressed(direction, function () {
        if (api) {
            api[direction]()
        }
    })
}
